// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3cO9Z","productName":"Table_productName__1yjC6"};